import { render, staticRenderFns } from "./FacebookLogo.vue?vue&type=template&id=a326f042&scoped=true"
var script = {}
import style0 from "./FacebookLogo.vue?vue&type=style&index=0&id=a326f042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a326f042",
  null
  
)

export default component.exports